import React from "react";
import wrapperStyles from "../../../styles/UI/wrappers.module.css";

const ColouredRoundWrapper = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode | React.ReactNode[];
    classes?: string;
    bgColor: string;
    borderColor?: string;
    height?: string;
    padding?: boolean;
    color?: string;
    width?: string;
    maxWidth?: string;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    // Opt-in: makes this focusable and operable with Enter/Space, for callers using
    // onClick as a real button action rather than a decorative/already-focusable wrapper.
    interactive?: boolean;
    ariaLabel?: string;
  }
>(
  (
    {
      children,
      classes,
      bgColor,
      borderColor,
      height,
      padding,
      color,
      width,
      maxWidth,
      onClick,
      onMouseEnter,
      onMouseLeave,
      interactive,
      ariaLabel,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={`${wrapperStyles.colouredRoundWrapper} ${classes ? classes : null}`}
        style={{
          color: color,
          border: `1px solid ${borderColor ? borderColor : "transparent"}`,
          backgroundColor: bgColor,
          width: width ? width : "fit-content",
          maxWidth: maxWidth ? maxWidth : "unset",
          height: height ? height : "40px", //Todo: update to util variable
          padding: padding ? "var(--spacing-sm) var(--spacing-md)" : "none",
        }}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...(interactive && {
          role: "button",
          tabIndex: 0,
          "aria-label": ariaLabel,
          onKeyDown: (e: React.KeyboardEvent) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClick?.();
            }
          },
        })}
      >
        {children}
      </div>
    );
  },
);

export default ColouredRoundWrapper;
